import Associates from "./Associates";
import CallToAction from "./CallToAction";
import { useNavigate } from "react-router-dom";

const ServicePage = () => {
    const navigate = useNavigate();

    const loanData = [
        {
            title: "Personal Loan - Quick & Hassle-Free Approval",
            description: "Personalized loan solutions with flexible repayment options and competitive interest rates. No hidden fees and fast approvals with KRS FinSolutions.",
            icon: "fa-wallet",
            link: "/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Business Loan - Fuel Your Growth",
            description: "Empower your business with tailored financing solutions. Access working capital, expansion funds, and equipment financing with expert support.",
            icon: "fa-briefcase",
            link: "/business-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Home Loan - Your Dream Home Awaits",
            description: "Secure a home loan with competitive rates and expert guidance. Whether buying a new home or refinancing, we make the process simple and stress-free.",
            icon: "fa-home",
            link: "/home-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Mortgage Loan - Smart Financing for Homeowners",
            description: "Flexible mortgage solutions designed for homeowners. Benefit from low-interest rates, easy approvals, and expert assistance tailored to your needs.",
            icon: "fa-hand-holding-dollar",
            link: "/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Working Capital Loan - Maintain Cash Flow",
            description: "Short-term financing to manage operational expenses, inventory, and payroll. Flexible terms to keep your business running smoothly.",
            icon: "fa-money-bill-wave",
            link: "/working-capital-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Loan Against Shares - Leverage Your Investments",
            description: "Get funds against your demat shares and mutual funds without selling them. Quick approval and competitive rates.",
            icon: "fa-chart-line",
            link: "/loan-against-shares-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Working Capital Management - Optimize Cash Flow",
            description: "Strategic optimization of cash cycles to unlock tied-up liquidity, improve operational efficiency, and enhance financial stability through expert analysis and customized solutions.",
            icon: "fa-cogs",
            link: "/working-capital-management-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Fund-Based Lending – Comprehensive Financing",
            description: "Complete financing solutions including Cash Credit (CC), Overdraft (OD) limits, Term Loans, and Project Financing to support business growth, operations, and capital investments.",
            icon: "fa-credit-card",
            link: "/fund-based-lending-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Non-Fund Based Lending - Trade & Contract Support",
            description: "Arranging Letters of Credit (LC) and Bank Guarantees (BG) to facilitate trade and large-scale contracts.",
            icon: "fa-file-contract",
            link: "/non-fund-based-lending-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Debt Syndication - Large-Scale Project Financing",
            description: "End-to-end management from Information Memorandum (IM) preparation to final disbursement.",
            icon: "fa-handshake",
            link: "/debt-syndication-mumbai-thane-palghar-maharashtra-delhi-india",
        },


    ];

    return (
        <>
            <div className="other-pages-main-section service-page-fin">
                <h2 className="other-pages-title">Capital & Lending Solutions</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/loan-services-india")} style={{ cursor: "pointer" }}>Capital & Lending Solutions</span>
                </p>
            </div>

            <Associates />

            <div className="loan-card-main">
                <h2 className="sections-title-smco">
                    <span className="horizontal-line"></span>Our Core Services
                </h2>
                <p className="sections-description-smco">
                    Quick approvals, low rates, and hassle-free loans tailored for you.
                </p>

                <div className="loan-cards-container-smco">
                    {loanData.map((loan, index) => (
                        <div
                            key={index}
                            className="loan-card-smco"
                            onClick={() => navigate(loan.link)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="loan-card-container-icon-dashed-border">
                                <div className="loan-card-icon-container-smco">
                                    <i className={`fa-solid ${loan.icon} loan-card-icon-smco`}></i>
                                </div>
                            </div>
                            <h3 className="loan-card-title-smco">{loan.title}</h3>
                            <p className="loan-card-description-smco">{loan.description}</p>

                            {/* Learn More Button */}
                            <button
                                className="loan-card-button-smco"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(loan.link);
                                }}
                            >
                                <i className="fa-solid fa-arrow-right learn-more-arrow"></i>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <CallToAction />
        </>
    );
};

export default ServicePage;
